import { Button } from "../../../../components/tailwind/button";
import { Label } from "../../../../components/tailwind/label";
import { Input } from "../../../../components/tailwind/input";
import { inspectorInputClass, inspectorSelectClass } from "./RightInspectorStyles";
import { formatConditionRightForInput, parseConditionRightValue } from "../../utils/workflowSchemaUtils";

export function ConditionCatalogSelect({ value, onChange, conditions }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={inspectorSelectClass}
    >
      <option value="">Select...</option>
      {conditions.map((condition) => (
        <option key={condition.operator} value={condition.operator}>
          {condition.label}
        </option>
      ))}
    </select>
  );
}

export function ConditionNodeFields({ data, onUpdate, conditionsCatalog }) {
  const conditions = Array.isArray(data.conditions) ? data.conditions : [];
  const logic = data.logic || "AND";

  const updateConditions = (nextConditions) => {
    onUpdate({ ...data, conditions: nextConditions, hasError: false });
  };

  const updateConditionRow = (index, patch) => {
    const next = conditions.map((row, idx) => (idx === index ? { ...row, ...patch } : row));
    updateConditions(next);
  };

  return (
    <div className="space-y-3 border-t border-gray-100 dark:border-slate-800 pt-4">
      <Label className="text-xs font-semibold text-gray-700 dark:text-gray-300">When should this branch run?</Label>
      <select
        value={logic}
        onChange={(e) => onUpdate({ ...data, logic: e.target.value, hasError: false })}
        className={inspectorSelectClass}
      >
        <option value="AND">All rules below must match</option>
        <option value="OR">Any one rule can match</option>
      </select>

      <Label className="text-xs font-semibold text-gray-700 dark:text-gray-300">Rules</Label>
      {conditions.map((row, index) => (
        <div key={`condition-${index}`} className="space-y-2 rounded border border-gray-200 dark:border-slate-800 p-3">
          <Input
            value={row.left || ""}
            placeholder="Context key to check (e.g. age)"
            className={inspectorInputClass}
            onChange={(e) => updateConditionRow(index, { left: e.target.value })}
          />
          {conditionsCatalog?.length ? (
            <ConditionCatalogSelect
              value={row.operator || ""}
              onChange={(operator) => updateConditionRow(index, { operator })}
              conditions={conditionsCatalog}
            />
          ) : (
            <Input
              value={row.operator || ""}
              placeholder="Operator (e.g. greater_than)"
              className={inspectorInputClass}
              onChange={(e) => updateConditionRow(index, { operator: e.target.value })}
            />
          )}
          <Input
            value={formatConditionRightForInput(row.right)}
            placeholder={
              ["greater_than", "less_than"].includes(row.operator)
                ? "Number to compare with"
                : "Value to compare with"
            }
            className={inspectorInputClass}
            onChange={(e) =>
              updateConditionRow(index, {
                right: parseConditionRightValue(e.target.value, row.operator)
              })
            }
          />
          <Button
            type="button"
            variant="ghost"
            className="h-7 text-xs text-red-600 dark:text-red-400"
            onClick={() => updateConditions(conditions.filter((_, idx) => idx !== index))}
          >
            Remove condition
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        className="w-full h-8 text-xs"
        onClick={() =>
          updateConditions([...conditions, { left: "", operator: "equals", right: "" }])
        }
      >
        Add rule
      </Button>
    </div>
  );
}
